import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import { memo } from 'react';
import styles from './RewardsContainsWidget.scss';
import Contains, { IContainsItem } from '~/components/ItemContains/Contains';
import { IGachaBannerDefaultReward } from '~/types/gacha';
import { items as ITEMS_TYPES } from '@wg/wows-entities/const';

interface IRewardsContainsWidget {
    reward: IGachaBannerDefaultReward;
}

const RewardsContainsWidget = ({ reward }: IRewardsContainsWidget) => {
    const items: IContainsItem[] = reward.items.map((item) => {
        return {
            content: (
                <WoWSEntity
                    key={`gacha_tooltip_reward_${reward.name}_item_${item.id}`}
                    type={item.type}
                    id={item.id}
                    amount={item.amount}
                    presentation={{
                        withText: true,
                        withTooltip: true,
                        iconPosition: 'left',
                        renderWithoutFade: true,
                        hiddenInlineShip: item.type === ITEMS_TYPES.CREWS,
                    }}
                    customisation={item.customisation}
                />
            ),
            id: item.id?.toString(),
            type: item.type,
            isExistsInInventory: true,
        };
    });

    return (
        <div className={styles.wrapper}>
            <Contains items={items} isLarge={false} />
        </div>
    );
};

export default memo(RewardsContainsWidget);
